<!--Basic google map starts-->
<div class="row">
  <div class="col-12">
    <div class="content-header">Google Map</div>
  </div>
</div>
<section id="">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-content">
                    <div class="card-body mt-2">
                        <agm-map [latitude]="lat" [longitude]="lng">
                            <agm-marker [latitude]="lat" [longitude]="lng"></agm-marker>
                        </agm-map>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!--Basic google map ends-->
